import ReactGA from 'react-ga4';

// Google Analytics -seuranta
const GA_MEASUREMENT_ID = 'G-S8R8DBDJSV';

// Tapahtumakategoriat
export const EVENT_CATEGORIES = {
	USER_INTERACTION: 'user_interaction',
	NAVIGATION: 'navigation',
	FORM: 'form',
	CONTENT: 'content',
	EXTERNAL_LINK: 'external_link',
};

// Tapahtumatyypit
export const EVENT_ACTIONS = {
	PAGE_VIEW: 'page_view',
	ROLE_SELECTION: 'role_selection',
	COMPONENT_VIEW: 'component_view',
	BUTTON_CLICK: 'button_click',
	FORM_SUBMIT: 'form_submit',
	LINK_CLICK: 'link_click',
	SCROLL: 'scroll',
};

// Alusta Google Analytics
export const initGA = () => {
	ReactGA.initialize(GA_MEASUREMENT_ID);
};

// Seuraa sivun näyttämistä
export const trackPageView = (path) => {
	ReactGA.send({ hitType: 'pageview', page: path });
};

// Seuraa tapahtumia
export const trackEvent = (category, action, label, value = null) => {
	const eventData = {
		category: category,
		action: action,
		label: label,
	};

	if (value !== null) {
		eventData.value = value;
	}

	ReactGA.event(eventData);
};

// Seuraa komponentin näyttämistä
export const trackComponentView = (componentName) => {
	trackEvent(
		EVENT_CATEGORIES.CONTENT,
		EVENT_ACTIONS.COMPONENT_VIEW,
		componentName,
	);
};

// Seuraa käyttäjäroolin valintaa
export const trackRoleSelection = (role) => {
	trackEvent(
		EVENT_CATEGORIES.USER_INTERACTION,
		EVENT_ACTIONS.ROLE_SELECTION,
		role,
	);
};

// Seuraa painikkeen klikkausta
export const trackButtonClick = (buttonName) => {
	trackEvent(
		EVENT_CATEGORIES.USER_INTERACTION,
		EVENT_ACTIONS.BUTTON_CLICK,
		buttonName,
	);
};

// Seuraa lomakkeen lähetystä
export const trackFormSubmit = (formName, success = true) => {
	trackEvent(
		EVENT_CATEGORIES.FORM,
		EVENT_ACTIONS.FORM_SUBMIT,
		formName,
		success ? 1 : 0,
	);
};

// Seuraa ulkoisen linkin klikkausta
export const trackExternalLink = (linkName, url) => {
	trackEvent(
		EVENT_CATEGORIES.EXTERNAL_LINK,
		EVENT_ACTIONS.LINK_CLICK,
		`${linkName}: ${url}`,
	);
};

// Seuraa sivun vieritystä
export const trackScroll = (scrollPercentage) => {
	trackEvent(
		EVENT_CATEGORIES.USER_INTERACTION,
		EVENT_ACTIONS.SCROLL,
		'page_scroll',
		scrollPercentage,
	);
};
